import { useCallback, useEffect, useRef, useState } from "react";
import { DEFAULT_CONSTRAINTS } from "./constants";
import { useBrowserMultiFormatReader } from "./useBrowserMultiFormatReader";
import { deepCompareObjects } from "./utils";
function isUseZxingOptionsWithDeviceId(options) {
    return options.deviceId !== undefined;
}
export var useZxing = function (options) {
    if (options === void 0) { options = {}; }
    var hints = options.hints, timeBetweenDecodingAttempts = options.timeBetweenDecodingAttempts, _a = options.onResult, onResult = _a === void 0 ? function () { } : _a, _b = options.onError, onError = _b === void 0 ? function () { } : _b;
    var deviceId = isUseZxingOptionsWithDeviceId(options)
        ? options.deviceId
        : undefined;
    var _c = useState(isUseZxingOptionsWithDeviceId(options) ? undefined : options.constraints), constraints = _c[0], setConstraints = _c[1];
    var resultHandlerRef = useRef(onResult);
    var errorHandlerRef = useRef(onError);
    var ref = useRef(null);
    var reader = useBrowserMultiFormatReader({
        hints: hints,
        timeBetweenDecodingAttempts: timeBetweenDecodingAttempts,
    });
    var decodeCallback = useCallback(function (result, error) {
        if (result)
            resultHandlerRef.current(result);
        if (error)
            errorHandlerRef.current(error);
    }, []);
    var startDecoding = useCallback(function () {
        if (!ref.current)
            return;
        if (deviceId) {
            reader.decodeFromVideoDevice(deviceId, ref.current, decodeCallback);
        }
        else {
            reader.decodeFromConstraints(constraints !== null && constraints !== void 0 ? constraints : DEFAULT_CONSTRAINTS, ref.current, decodeCallback);
        }
    }, [reader, deviceId, constraints, decodeCallback]);
    var stopDecoding = useCallback(function () {
        reader.reset();
    }, [reader]);
    useEffect(function () {
        resultHandlerRef.current = onResult;
    }, [onResult]);
    useEffect(function () {
        errorHandlerRef.current = onError;
    }, [onError]);
    useEffect(function () {
        var isConstraintsValueSame = deepCompareObjects(constraints, options.constraints);
        console.log(isConstraintsValueSame);
        if (!isConstraintsValueSame) {
            setConstraints(options.constraints);
        }
    }, [constraints, options, setConstraints]);
    useEffect(function () {
        startDecoding();
        return function () {
            stopDecoding();
        };
    }, [startDecoding, stopDecoding]);
    return { ref: ref, start: startDecoding, stop: stopDecoding };
};
